import React, { Component } from 'react';
import './recruit.css';
import hq from '../../assets/images/recruit/headquarters.jpg';
import tokyo from '../../assets/images/recruit/tokyo.jpg';
import engineer from '../../assets/images/recruit/engineer.jpg';
import programmer from '../../assets/images/recruit/programmer.jpg';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

class Recruit extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>採用情報 | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                <div id='recruit-container'>
                    <div className='container-box banner-container' id='recruit-banner-container'>
                        <div className='overlay'></div>
                        <div className='row'>
                            <div className='col'>
                                <h1>採用情報</h1>
                                <h3>RECRUITMENT</h3>
                            </div>
                        </div>
                    </div>

                    {/* HEADQUARTERS */}
                    <div className='container-box recruit-type-box' id='headquarters-container'>
                        <div className='row row-title'>
                            <div className='col col-hr'><hr></hr></div>
                            <div className='col-12 col-md-8 col-lg-6 col-xl-5'>
                                <h1>新卒採用【本社】</h1>
                                <h5>NEW GRADUATES RECRUITMENT【MAIN OFFICE】</h5>
                            </div>
                            <div className='col col-hr'><hr></hr></div>
                        </div>
                        <div className='row row-content'>
                            <div className='col col-img'>
                                <img src={hq} alt="nalsoft-employees" />
                            </div>
                            <div className='col-12 col-md-7 col-content'>
                                <table className='recruit-table'>
                                    <tbody>
                                        <tr>
                                            <th>募集職種</th>
                                            <td>システムエンジニア</td>
                                        </tr>
                                        <tr>
                                            <th>応募資格</th>
                                            <td>2024年3月に大学院・大学・専門学校を卒業見込みの方</td>
                                        </tr>
                                        <tr>
                                            <th>勤務地</th>
                                            <td>名古屋市内及び近郊 (東京支社勤務も可能)</td>
                                        </tr>
                                        <tr>
                                            <th>募集人員</th>
                                            <td>10名</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='btn-container'>
                                    <Link to='/recruit/headquarter' className="btn-details">詳細を見る</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END OF HEADQUARTERS */}

                    {/* TOKYO */}
                    <div className='container-box recruit-type-box' id='tokyo-container'>
                        <div className='row row-title'>
                            <div className='col col-hr'><hr></hr></div>
                            <div className='col-12 col-md-8 col-lg-6 col-xl-4'>
                                <h1>新卒採用【東京】</h1>
                                <h5>NEW GRADUATES RECRUITMENT【TOKYO】</h5>
                            </div>
                            <div className='col col-hr'><hr></hr></div>
                        </div>
                        <div className='row row-content'>
                            <div className='col col-img'>
                                <img src={tokyo} alt="nalsoft-employees" />
                            </div>
                            <div className='col-12 col-md-7 col-content'>
                                <table className='recruit-table'>
                                    <tbody>
                                        <tr>
                                            <th>募集職種</th>
                                            <td>システムエンジニア</td>
                                        </tr>
                                        <tr>
                                            <th>応募資格</th>
                                            <td>2024年3月に大学院・大学・専門学校を卒業見込みの方</td>
                                        </tr>
                                        <tr>
                                            <th>勤務地</th>
                                            <td>東京支社または東京都内及び近郊</td>
                                        </tr>
                                        <tr>
                                            <th>募集人員</th>
                                            <td>3名</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='btn-container'>
                                    <Link to='/recruit/tokyo' className="btn-details">詳細を見る</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END OF TOKYO */}

                    {/* SYSTEM ENGINEER */}
                    <div className='container-box recruit-type-box' id='engineer-container'>
                        <div className='row row-title'>
                            <div className='col col-hr'><hr></hr></div>
                            <div className='col-12 col-md-8 col-lg-6'>
                                <h1>中途採用／システムエンジニア</h1>
                                <h5>MID-CAREER RECRUITMENT / SYSTEM ENGINEER</h5>
                            </div>
                            <div className='col col-hr'><hr></hr></div>
                        </div>
                        <div className='row row-content'>
                            <div className='col col-img'>
                                <img src={engineer} alt="nalsoft-employees" />
                            </div>
                            <div className='col-12 col-md-7 col-content'>
                                <table className='recruit-table'>
                                    <tbody>
                                        <tr>
                                            <th>募集職種</th>
                                            <td>システムエンジニア</td>
                                        </tr>
                                        <tr>
                                            <th>応募資格</th>
                                            <td>プロジェクトマネジメントの経験がある方システム開発の経験がある方</td>
                                        </tr>
                                        <tr>
                                            <th>勤務地</th>
                                            <td>①本社
                                                <br />名古屋市内及び近郊（東京支社勤務も可能）<br />
                                                <br />②東京
                                                <br />東京支社または東京都内及び近郊
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>募集</th>
                                            <td>随時募集</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='btn-container'>
                                    <Link to='/recruit/mid-level-engineer' className="btn-details">詳細を見る</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END OF SYSTEM ENGINEER */}

                    {/* PROGRAMMER */}
                    <div className='container-box recruit-type-box' id='programmer-container'>
                        <div className='row row-title'>
                            <div className='col col-hr'><hr></hr></div>
                            <div className='col-12 col-md-8 col-lg-5 col-xl-6'>
                                <h1>中途採用／プログラマー</h1>
                                <h5>MID-CAREER RECRUITMENT / PROGRAMMER</h5>
                            </div>
                            <div className='col col-hr'><hr></hr></div>
                        </div>
                        <div className='row row-content'>
                            <div className='col col-img'>
                                <img src={programmer} alt="nalsoft-employees" />
                            </div>
                            <div className='col-12 col-md-7 col-content'>
                                <table className='recruit-table'>
                                    <tbody>
                                        <tr>
                                            <th>募集職種</th>
                                            <td>プログラマー</td>
                                        </tr>
                                        <tr>
                                            <th>応募資格</th>
                                            <td>何等かのシステム開発経験がある方<br />＊経験の浅い方も歓迎です</td>
                                        </tr>
                                        <tr>
                                            <th>勤務地</th>
                                            <td>①本社
                                                <br />名古屋市内及び近郊（東京支社勤務も可能）<br />
                                                <br />②東京
                                                <br />東京支社または東京都内及び近郊
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>募集</th>
                                            <td>随時募集</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className='btn-container'>
                                    <Link to='/recruit/mid-level-programmer' className="btn-details">詳細を見る</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END OF PROGRAMMER */}
                </div>
            </React.Fragment>
        )
    }
}

export default Recruit;